import { useAuthenticatedUserQuery } from "@/features/auth/api/profile-queries"
import { isAdminAccountType } from "@/features/auth/api/types"
import {
  isFeatureEnabled,
  useFeatureFlagQuery,
} from "@/features/feature-flags/api/feature-flag-queries"

export type UseFeatureFlagOptions = {
  /** ADMIN / SUPER_ADMIN / PLATFORM_ENGINEER always pass, even when the flag is off. */
  bypassForAdmin?: boolean
}

export function useFeatureFlag(
  key: string,
  options: UseFeatureFlagOptions = {}
) {
  const { bypassForAdmin = false } = options
  const { data: userInfo, isLoading: isAuthLoading } =
    useAuthenticatedUserQuery(bypassForAdmin)
  const { data, isLoading: isFlagLoading, isError } = useFeatureFlagQuery(key)

  const isAdmin = bypassForAdmin && isAdminAccountType(userInfo?.accountType)
  const enabled = isAdmin || isFeatureEnabled(data?.value)
  const isLoading =
    (bypassForAdmin && isAuthLoading) || (!isAdmin && isFlagLoading)

  return {
    enabled,
    isLoading,
    isError,
    /** Safe to fetch feature data once access is known and allowed. */
    queriesEnabled: !isLoading && enabled,
  }
}
